import moment from 'moment';
import {
  isActiveTimezoneConfigured,
} from '@skygroup/shared/utils/momentTzPlugin';

export const CANCELLATION_DATE_DISPLAY_FORMAT = 'MMMM DD, YYYY HH:mm';

export type CancellationPenaltiesLike = {
  policies?: Array<{
    amount_show?: string | number;
    end_at?: string;
  }>;
};

/** Free-cancellation policy row (amount_show === 0), same source as CancellationTooltip. */
export function getFreeCancellationPolicyEndAt(
  cancellationPenalties?: CancellationPenaltiesLike
): string | undefined {
  return cancellationPenalties?.policies?.find(
    (p) => Number(p?.amount_show) === 0 && p?.end_at
  )?.end_at;
}

/**
 * Profile timezone via formatTZ when `localStorage.activeTz` is set (backoffice).
 * Otherwise browser-local time (typical B2C).
 */
export function formatCancellationDateLocal(
  value: string | number
): string {
  const fmt = CANCELLATION_DATE_DISPLAY_FORMAT;
  const m =
    typeof value === 'number' ? moment(value * 1000) : moment(value);
  if (isActiveTimezoneConfigured()) {
    return m.formatTZ(fmt);
  }
  return m.format(fmt);
}

/**
 * Prefer policy `end_at` (matches tooltip) over `free_cancelation_date` epoch when both exist.
 */
export function resolveFreeCancellationDisplayValue(
  dateMS?: number | boolean,
  cancellationPenalties?: CancellationPenaltiesLike
): string | number | undefined {
  if (typeof dateMS === 'boolean') {
    return undefined;
  }
  const policyEndAt = getFreeCancellationPolicyEndAt(cancellationPenalties);
  if (policyEndAt) {
    return policyEndAt;
  }
  if (typeof dateMS === 'number') {
    return dateMS;
  }
  return undefined;
}
